import { ConfirmDialog } from '@/components/common/ConfirmDialog';
import { useDeleteHoliday } from '../hooks/useHolidayMutations';
import type { Holiday } from '../types/holiday.types';
import { formatHolidayDates } from '../utils/holidayCalendar';

interface HolidayDeleteDialogProps {
  holiday: Holiday | null;
  onClose: () => void;
}

export function HolidayDeleteDialog({ holiday, onClose }: HolidayDeleteDialogProps) {
  const deleteMutation = useDeleteHoliday(onClose);

  return (
    <ConfirmDialog
      open={holiday !== null}
      onOpenChange={(open) => !open && onClose()}
      title="Delete this holiday?"
      description={
        holiday
          ? `${holiday.name}, ${formatHolidayDates(holiday)}. These days count as working days again. You cannot undo this.`
          : undefined
      }
      confirmLabel="Delete"
      confirmVariant="destructive"
      isPending={deleteMutation.isPending}
      pendingLabel="Deleting..."
      onConfirm={() => holiday && deleteMutation.mutate(holiday.id)}
    />
  );
}
